import { Box, Circle, Text } from '@factorialco/deprecated-design-system'
import { Alert, AlertDescription, AlertTitle } from '@factorialco/f0-react/dist/experimental'

interface InfoComponentProps {
  messages: string[]
  color: 'destructive' | 'positive' | 'info'
}

const MAX_MESSAGES = 6

export const InfoComponent = ({ messages, color }: InfoComponentProps) => {
  const message = messages.length === 1 ? messages[0] : null
  const hiddenMessages = Math.max(messages.length - MAX_MESSAGES, 0)
  return message ? (
    <Box paddingTop="s12">
      <Alert variant={color}>
        <AlertTitle>{message}</AlertTitle>
      </Alert>
    </Box>
  ) : (
    <Box paddingTop="s12">
      <Alert variant={color}>
        <AlertTitle>{messages[0]}</AlertTitle>
        <AlertDescription>
          {messages
            .filter((_, i) => i > 0 && i < MAX_MESSAGES)
            .map((m, i) => (
              <Box flexDirection="row" alignItems="center" gap="s4" key={i}>
                <Circle size={5} type="primary" />
                <Text.Normal ellipsis title={m} size="200">
                  {m}
                </Text.Normal>
              </Box>
            ))}
          {hiddenMessages > 0 && <Text.Normal size="200">...</Text.Normal>}
        </AlertDescription>
      </Alert>
    </Box>
  )
}
